module.exports = __webpack_public_path__ + "img/imgGift.a2cd3c3e.svg";